import { MainButton } from "component_old/micro/action/MainButton"
import { ImageMask } from "component_old/micro/design/ImageMask"
import { CtxModal } from "component_old/modal/ctxModal"
import { Localization } from "libs/localization/localization"
import { EFonts, EShadows } from "libs/style/styling"
import { EScrolls, scrollToAnchor } from "libs/utils/logic/browserLogic"
import React, { useContext } from "react"
import styled from "styled-components/macro"

interface Props {
  className?: string
}

export const TemporaryEditor = (props: Props): JSX.Element => {
  const ctxModal = useContext(CtxModal)

  return (
    <S_TemporaryEditor className={props.className}>
      <ImageMask
        randomizePosition={true}
        image="contour"
        repeat={true}
        degress={36}
        step={60}
        positionX={"4px"}
        positionY={"474px"}
      />
      <S_Title>{Localization.TEMPORARY_TITLE}</S_Title>
      <S_Desc>{Localization.TEMPORARY_DESC}</S_Desc>
      <S_Button
        text={Localization.CONTACT_US}
        type="primary"
        shadow={EShadows.STRONG}
        onClick={() => {
          document.querySelector("body").style.overflow = "unset"
          scrollToAnchor(EScrolls.contact, "auto")
          ctxModal.changeModal(null)
        }}
      />
    </S_TemporaryEditor>
  )
}

const S_TemporaryEditor = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding: 25px;
  position: relative;
  @media only screen and (min-width: 1260px) {
    padding: 50px;
  }
`

const S_Title = styled.span`
  display: block;
  color: #ffffff;
  font-size: 19px;
  line-height: 30px;
  font-family: ${EFonts.Bold};
  margin: 0 0 20px 0;
  text-align: left;
  width: 100%;
  z-index: 1;
  @media only screen and (min-width: 1260px) {
    font-size: 33px;
    line-height: 60px;
  }
`

const S_Desc = styled.span`
  display: block;
  color: #ffffff;
  font-size: 15px;
  line-height: 27px;
  font-family: ${EFonts.Medium};
  text-align: left;
  z-index: 1;
  @media only screen and (min-width: 1260px) {
    font-size: 17px;
    line-height: 29px;
  }
`

const S_Button = styled(MainButton)`
  margin: 40px 0 0 0;
  z-index: 1;
  @media only screen and (min-width: 1260px) {
    margin: 50px 0 0px 0;
  }
`
